import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable, throwError } from 'rxjs';
import { TokenResult } from '../models';
import { RefreshTokenProvider } from '@symphony-solo/shared/token-interceptor/src';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationFacade } from '../+state';
import { AlertService } from '@symphony-solo/shared/alert/src/lib';

@Injectable()
export class RefreshTokenService extends RefreshTokenProvider {
  private path = 'refreshauthentication';
  constructor(private httpService: HttpService, private authFacade: AuthenticationFacade, private alertService: AlertService) {
    super();
  }

  public refreshToken(tokenInfo: TokenResult): Observable<string> {
    return this.httpService.makePost<TokenResult, TokenResult>(this.path, tokenInfo).pipe(
      map((tokenAndRefreshToken) => {
        this.authFacade.setTokenInformation(new TokenResult(tokenAndRefreshToken.token, tokenAndRefreshToken.refreshToken));
        return tokenAndRefreshToken.token;
      }),
      catchError((error) => {
        this.authFacade.logoutSuccess();
        const okButton = {
          text: 'OK',
          cssClass: 'okButton centerButton',
        };
        this.alertService.presentAlert('Alert', 'Session expired, please log in again', [okButton]);
        return throwError(error);
      })
    );
  }
}
